function triggers() {
  const menuTriggers = [...document.querySelectorAll(".js-menu-trigger")];
  const menu = document.querySelector(".js-menu");
  menuTriggers.map(trigger => {
    trigger.addEventListener('click', (event) => {
      
      menu.classList.toggle('active');
      menu.toggleAttribute("hidden");
      
      const expanded = trigger.getAttribute('aria-expanded')
      if (expanded === 'false') {
        trigger.setAttribute('aria-expanded', 'true')
      } else {
        trigger.setAttribute('aria-expanded', 'false')
      }
    })
  });
}
triggers();

function accordionBuild(el) {
  el.classList.add('js-accordion');
  el.setAttribute('id', 'accordionGroup');
  el.setAttribute('role', 'presentation');
  Array.prototype.slice.call(el.querySelectorAll('.nav-multi-col__column')).forEach(function (column) {
    const panel = column.querySelector('.nav-multi-col__panel');
    panel.setAttribute('hidden', '');
    panel.classList.add('js-accordion-panel');
    const title = column.querySelector('.nav-multi-col__heading');
    title.parentElement.classList.add('js-accordion-trigger');
    title.classList.add('js-accordion-title');
  });
}

function accordionDestroy(el) {
  el.classList.remove('js-accordion');
  el.removeAttribute('id');
  el.removeAttribute('role');
  Array.prototype.slice.call(el.querySelectorAll('.nav-multi-col__column')).forEach(function (column) {
    const panel = column.querySelector('.nav-multi-col__panel');
    panel.removeAttribute('hidden');
    panel.classList.remove('js-accordion-panel');
    const title = column.querySelector('.nav-multi-col__heading');
    title.parentElement.classList.remove('js-accordion-trigger');
    title.classList.remove('js-accordion-title');
  });
}

function accordion() {
  Array.prototype.slice.call(document.querySelectorAll('.js-accordion')).forEach(function (accordion) {

    // Create the array of toggle elements for the accordion group
    const triggers = Array.prototype.slice.call(accordion.querySelectorAll('.js-accordion-trigger'));
    const panels = Array.prototype.slice.call(accordion.querySelectorAll('.js-accordion-panel'));

    accordion.onclick = function foo(event) {
      const target = event.target;

      if (target.classList.contains('js-accordion-trigger')) {
        // Check if the current toggle is expanded.
        const isExpanded = target.getAttribute('aria-expanded') == 'true';
        const active = accordion.querySelector('[aria-expanded="true"]');
        console.log(isExpanded);

        if (!isExpanded) {
          // Set the expanded state on the triggering element
          target.setAttribute('aria-expanded', 'true');
          // Hide the accordion sections, using aria-controls to specify the desired section
          document.getElementById(target.getAttribute('aria-controls')).removeAttribute('hidden');

        }
        else if (isExpanded) {
          // Set the expanded state on the triggering element
          target.setAttribute('aria-expanded', 'false');
          // Hide the accordion sections, using aria-controls to specify the desired section
          document.getElementById(target.getAttribute('aria-controls')).setAttribute('hidden', '');

        }

        event.preventDefault();
      }
    } 

    // Bind keyboard behaviors on the main accordion container
    accordion.addEventListener('keydown', function (event) {
      const target = event.target;
      const key = event.which.toString();
      // 33 = Page Up, 34 = Page Down
      const ctrlModifier = (event.ctrlKey && key.match(/33|34/));

      // Is this coming from an accordion header?
      if (target.classList.contains('js-accordion-trigger')) {
        // Up/ Down arrow and Control + Page Up/ Page Down keyboard operations
        // 38 = Up, 40 = Down
        if (key.match(/38|40/) || ctrlModifier) {
          const index = triggers.indexOf(target);
          const direction = (key.match(/34|40/)) ? 1 : -1;
          const length = triggers.length;
          const newIndex = (index + length + direction) % length;

          triggers[newIndex].focus();

          event.preventDefault();
        }
        else if (key.match(/35|36/)) {
          // 35 = End, 36 = Home keyboard operations
          switch (key) {
              // Go to first accordion
            case '36':
              triggers[0].focus();
              break;
              // Go to last accordion
            case '35':
              triggers[triggers.length - 1].focus();
              break;
          }

          event.preventDefault();
        }
      }
      else if (ctrlModifier) {
        // Control + Page Up/ Page Down keyboard operations
        // Catches events that happen inside of panels
        panels.forEach(function (panel, index) {
          if (panel.contains(target)) {
            triggers[index].focus();

            event.preventDefault();
          }
        });
      }
    });
  });
}

// Checks screen width.
function mobileCheck(mq) {
  if (mq.matches) {
    return true;
  } 
  else {
    return false;    
  }
}

const mq = window.matchMedia("(max-width: 1200px)");
let timeout;

['load','resize'].forEach(evt => 
  window.addEventListener(evt, function(e) {
    // e.target.removeEventListener(e.type, arguments.callee);

    if (!timeout) {
      timeout = setTimeout(function() {

        // Reset timeout
        timeout = null;
        const isMobile = mobileCheck(mq);
        if (isMobile) {
          accordionBuild(document.querySelector('.nav-multi-col'));
          accordion();
        }
        else if (!isMobile) {
          accordionDestroy(document.querySelector('.nav-multi-col'));
        }
      }, 500);
    }
  })
)